var _defs, _g, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoungeStartup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4iyfzea6wa",
    d: "M9 0c5.555 3.086 9 8.941 9 15.296V25H0v-9.704C0 8.94 3.445 3.086 9 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30D79F",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12 30H24V33H12z",
    transform: "translate(-32 -451) translate(20 441) translate(12 10)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -451) translate(20 441) translate(12 10) translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#31D7A0",
    d: "M6 16.5l6 8.5H1.447c-.414 0-.75-.336-.75-.75 0-.155.048-.306.138-.433L6 16.5z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31D7A0",
    d: "M24 17l6 8H19.5c-.414 0-.75-.336-.75-.75 0-.162.053-.32.15-.45L24 17z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "matrix(-1 0 0 1 48 0)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#00AE74",
    xlinkHref: "#4iyfzea6wa"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 3,
    stroke: "#FFF",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeStartup);
export default __webpack_public_path__ + "static/media/lounge-startup.10f4a5f9.svg";
export { ForwardRef as ReactComponent };